import { assert_string_hash_sha256 } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { FIELD_GRID2D_MODE__base } from '../../_base/FIELD_GRID2D_MODE__base';
import { FIELD__list_lora } from '../../_primitives/list/FIELD__list_lora';
import { FIELD__ml_asset_lora } from './FIELD__ml_asset_lora';

export class FIELD_GRID2D_MODE__all_loras_except_one extends FIELD_GRID2D_MODE__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_GRID2D_MODE__ALL_LORAS_EXCEPT_ONE;

  /*
   *
   */
  hash_selected!: string;
  hashes_all!: string[];

  /*
   * FIELDS
   */
  //todo: finish tokens positions
  // @FIELD_PRIMITIVE__int.init_as_field(
  //   {
  //     value: 0,
  //     value_range: DTO__number_range.ZERO.clone(),
  //     values_allowed: DTO__number_range.ZERO.clone(),
  //     //
  //     slider_step: 1,
  //     slider_step_values: [1, 2, 3, 4, 5],
  //   },
  //   { ui__has_component: false, grid2d__can_be_dimension: false },
  // )
  // tokens_positions!: FIELD_PRIMITIVE__int;

  /*
   *
   */

  get grid2d_dimension_values() {
    return this.hashes_all;
  }

  /*
   *
   */

  constructor() {
    super();

    this.hash_selected = ENUM__string_id_empty.HASH_SHA256;
    this.hashes_all = [];
  }

  init_loras(loras: FIELD__ml_asset_lora[]) {
    this.hashes_all = loras.map(item => item.model.get_value());

    if (this.hashes_all.is_empty()) this.hashes_all = [ENUM__string_id_empty.HASH_SHA256];

    /*
     *
     */
    //todo: finish tokens positions
    // if (this.tokens_sequences.is_empty()) {
    //   this.tokens_sequences.push([]);
    //   this.tokens_positions.set_value_range(DTO__number_range.ZERO.clone());
    //   this.tokens_positions.values_allowed = DTO__number_range.ZERO.clone();
    // } else {
    //   let values_allowed = new DTO__number_range(1, this.tokens_sequences.length);
    //   this.tokens_positions.values_allowed = values_allowed.clone();

    //   let values_range_current = this.tokens_positions.get_value_range();

    //   let value_range_new = values_allowed.clamp_range(values_range_current);
    //   this.tokens_positions.set_value_range(value_range_new);
    // }
  }

  grid2d_dimension__set_value(hash: any) {
    assert_string_hash_sha256(hash);

    this.hash_selected = hash;
    this.hashes_all = [];
  }

  grid2d_dimension__apply_for(graph: DTO_GRAPH__instance) {
    let fields_map = graph.fields__get_map();

    let loras_lists = fields_map.values().filter(field => field instanceof FIELD__list_lora);

    for (let loras_list of loras_lists) {
      for (let item of loras_list.items) {
        if (this.hash_selected != item.model.get_value()) continue;

        let edges_to_delete = graph.edges__get_related_to_fields([item]);
        graph.edges__delete(edges_to_delete);

        loras_list.item_remove(item);
      }
    }

    graph.field__replace(this);
  }
}
